export const blogSections = [
  {
    type: "hero",
    title: "Cold Chain Logistics Insights from an Operating UAE Fleet",
    paragraphs: [
      "Refrigerated transport in the UAE runs on details that rarely make it into a service brochure — which districts restrict delivery vehicles, what a loading dock barrier does to route planning, how ambient heat changes cargo handling between June and January, and where regulation sets the line.",
      "These guides cover what we deal with running vans and trucks across Dubai, Sharjah, and the wider Emirates every day. Written for businesses managing their own cold chain operations rather than for search engines.",
    ],
  },
  {
    type: "posts",
  },
];
